import { getApiMessage } from '@/mixins/Extras/ApiResponse'
import { signOut } from 'aws-amplify/auth'

const AUTH_SESSION_ERROR_PATTERNS = [
  /access token has been revoked/i,
  /token has been revoked/i,
  /refresh token has been revoked/i,
  /invalid login token/i,
  /not authorized/i,
  /unauthorized/i,
  /user is not authenticated/i,
  /user not authenticated/i,
  /session expired/i,
  /expired token/i,
  /token expired/i,
  /invalid session/i,
]

/**
 * Detect Cognito / GraphQL auth failures that require a fresh login.
 */
export function isAuthSessionError(source) {
  const message = getApiMessage(source, '')
  if (!message) return false
  return AUTH_SESSION_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/**
 * Clear portal auth state and return user to the login screen.
 */
export async function forcePortalLogout(store, { router } = {}) {
  try {
    await signOut({ global: true })
  } catch {
    // Session may already be invalid after remote logout.
  }

  store.commit('CLEAR_SESSION')
  store.commit('RESET_WORKSPACE')
  store.commit('SET_AUTHENTICATED', false)

  if (typeof window === 'undefined') return

  try {
    if (router && typeof router.push === 'function') {
      await router.push({ path: '/' })
      return
    }
  } catch {
    // Router navigation can fail when app state is corrupted — hard redirect below.
  }

  window.location.href = '/'
}

/**
 * When an API/auth error is session-related, sign out and send user to login.
 * @returns {boolean} true when logout was triggered
 */
export async function handleAuthSessionFailure(store, source, { router } = {}) {
  if (!isAuthSessionError(source)) {
    return false
  }
  await forcePortalLogout(store, { router })
  return true
}
